import isEmpty from "lodash/isEmpty";
import { arrayCount } from "@/js/utils";
import Vue from "vue";

const Facility = {
  install: Vue => {
    Vue.prototype.$facility = {
      facilityTypes: [
        {
          value: "1",
          text: "病院"
        },
        {
          value: "2",
          text: "学校"
        },
        {
          value: "3",
          text: "福祉施設"
        }
      ],
      shelterExists: [
        {
          value: "0",
          text: "無"
        },
        {
          value: "1",
          text: "有"
        }
      ],
      controlledAreas: [
        {
          value: "1",
          text: "ＰＡＺ圏内"
        },
        {
          value: "2",
          text: "ＵＰＺ圏内"
        },
        {
          value: "0",
          text: "ＵＰＺ圏外"
        }
      ],
      evacuationStatuses: [
        {
          value: "1",
          text: "屋内退避中"
        },
        {
          value: "2",
          text: "避難完了"
        },
        {
          value: "0",
          text: "不明"
        }
      ],
      facilityClasses: [
        {
          value: "1",
          text: "避難所"
        },
        {
          value: "2",
          text: "一時集合場所"
        },
        {
          value: "4",
          text: "避難退域時検査場所"
        }
      ],
      tempFacilityFlags: [
        {
          value: "0",
          text: "通常"
        },
        {
          value: "1",
          text: "臨時"
        }
      ],
      lodineDistributionPlaceFlags: [
        {
          value: "0",
          text: "配布場所でない"
        },
        {
          value: "1",
          text: "配布場所"
        }
      ],
      lodineDistriPlaceFlg: {
        "0": false,
        "1": true
      },
      designatedCategories: [
        {
          value: "1",
          text: "指定避難所"
        },
        {
          value: "2",
          text: "指定緊急避難場所兼避難所"
        },
        {
          value: "3",
          text: "指定緊急避難場所"
        }
      ],
      openingStatuses: [
        {
          value: "0",
          text: "未開設"
        },
        {
          value: "2",
          text: "開設中"
        },
        {
          value: "9",
          text: "閉鎖"
        },
        {
          value: "3",
          text: "不明"
        }
      ],
      congestSituations: [
        {
          value: "1",
          text: "空いている"
        },
        {
          value: "2",
          text: "平常"
        },
        {
          value: "3",
          text: "混雑している"
        }
      ],
      lifelineStatuses: [
        {
          value: "1",
          text: "使用可能"
        },
        {
          value: "0",
          text: "使用不可"
        }
      ],
      lifelines: {
        electricity: "電気",
        gas: "ガス",
        phone: "電話",
        water_supply: "水道"
      },
      evaLocationTypes: [
        {
          value: "1",
          text: "避難元"
        },
        {
          value: "2",
          text: "避難先"
        }
      ],
      faDetailsTypes: [
        {
          value: "1",
          fa_type:"1",
          text: "病院"
        },
        {
          value: "2",
          fa_type:"1",
          text: "診療所"
        },
        {
          value: "3",
          fa_type:"3",
          text: "介護老人保険施設"
        },
        {
          value: "4",
          fa_type:"3",
          text: "グループホーム"
        },
        {
          value: "5",
          fa_type:"3",
          text: "グループホーム、短期入所"
        },
        {
          value: "6",
          fa_type:"3",
          text: "軽費老人ホーム"
        },
        {
          value: "7",
          fa_type:"3",
          text: "施設入所支援"
        },
        {
          value: "8",
          fa_type:"3",
          text: "施設入所支援、短期入所"
        },
        {
          value: "9",
          fa_type:"3",
          text: "児童養護施設"
        },
        {
          value: "10",
          fa_type:"3",
          text: "宿泊型自立訓練（生活訓練）"
        },
        {
          value: "11",
          fa_type:"3",
          text: "情緒障害児短期治療施設"
        },
        {
          value: "12",
          fa_type:"3",
          text: "特定施設入居者生活介護"
        },
        {
          value: "13",
          fa_type:"3",
          text: "特定養護老人ホーム"
        },
        {
          value: "14",
          fa_type:"3",
          text: "福祉ホーム"
        },
        {
          value: "15",
          fa_type:"3",
          text: "有料老人ホーム"
        },
        {
          value: "16",
          fa_type:"3",
          text: "養護老人ホーム"
        },
        {
          value: "17",
          fa_type:"3",
          text: "短期入所"
        },
        {
          value: "18",
          fa_type:"3",
          text: "障害者施設"
        },
        {
          value: "19",
          fa_type:"3",
          text: "高齢者グループホーム等"
        },
        {
          value: "20",
          fa_type:"3",
          text: "障碍者グループホーム等"
        },
        {
          value: "21",
          fa_type:"3",
          text: "障害者支援施設"
        }
      ],
      getNameFromItems(
        value,
        items,
        itemValueKey = "value",
        itemTextKey = "text"
      ) {
        if (!items) {
          return "";
        }
        const data = items.find(
          item =>
            typeof item[itemValueKey] !== "undefined" &&
            item[itemValueKey] === value
        );
        if (data) {
          return data[itemTextKey];
        }
        return "";
      },
      getMultiNameFromItems(values, items, itemValueKey, itemTextKey) {
        if (!items) {
          return "";
        }
        if (Array.isArray(values)) {
          let names = [];
          values.forEach(value => {
            const data = items.find(
              item =>
                typeof item[itemValueKey] !== "undefined" &&
                item[itemValueKey] === value[itemValueKey]
            );
            if (data) {
              names.push(data[itemTextKey]);
            }
          });
          return names.join(", ");
        }
        return "";
      },
      evaMunicipalityNamesForDataTableItems(evaMunicipalities, municipalities) {
        if (
          arrayCount(evaMunicipalities) > 0 &&
          arrayCount(municipalities) > 0
        ) {
          let names = [];
          evaMunicipalities.find((evaMunicipality, index) => {
            const data = municipalities.find(municipality => {
              return evaMunicipality === municipality.value;
            });
            if (data) {
              const prefix = index > 0 ? " " : "";
              names.push(`${prefix}${data.text}`);
            }
          });
          return names.join(" \n");
        }
        return "";
      },
      evaAreaNamesForDataTableItems(evaAreas, areas) {
        return this.evaMunicipalityNamesForDataTableItems(evaAreas, areas);
      },
      municipalityTitle(facilityClass) {
        if (!facilityClass || facilityClass === "1") {
          return "避難元所属市町村";
        }
        return "市町村";
      },
      areaTitle(facilityClass) {
        if (!facilityClass || facilityClass === "1") {
          return "避難元所属地域（地区）";
        }
        return "地域（地区）";
      },
      facilityName(item) {
        return item.fa_name;
      },
      facilityNameKana(item) {
        return item.fa_name_kana;
      },
      facilityNameEn(item) {
        return item.fa_name_en;
      },
      facilityTypeName(item) {
        return this.getNameFromItems(
          item.vulner_ppl_fa_type,
          this.facilityTypes
        );
      },
      shelterExistName(item) {
        return this.getNameFromItems(item.shelter_exist, this.shelterExists);
      },
      controlledAreaName(item) {
        return this.getNameFromItems(
          item.controlled_area,
          this.controlledAreas
        );
      },
      evacuationStatusName(item) {
        return this.getNameFromItems(item.eva_status, this.evacuationStatuses);
      },
      facilityClassName(item) {
        return this.getNameFromItems(item.facility_class, this.facilityClasses);
      },
      tempFacilityFlagName(item) {
        return this.getNameFromItems(
          item.temp_facility_flg,
          this.tempFacilityFlags
        );
      },
      openingStatusName(item) {
        return this.getNameFromItems(item.opening_status, this.openingStatuses);
      },
      congestionSituationName(item) {
        return this.getNameFromItems(
          item.congest_situation,
          this.congestSituations
        );
      },
      designatedCategoryName(item) {
        return this.getNameFromItems(
          item.designated_category,
          this.designatedCategories
        );
      },
      lifelineStatusName(item, key) {
        return this.getNameFromItems(item[key], this.lifelineStatuses);
      },
      evaLocationTypeName(item) {
        return this.getNameFromItems(item.eva_location_type, this.EvaLocationTypes);
      },
      faDetailsTypeName(item) {
        return this.getNameFromItems(item.fa_details_type, this.FaDetailsTypes);
      },
      lodineDistriPlaceFlgValue(item) {
        return this.lodineDistriPlaceFlg[item.lodine_distri_place_flg];
      },
      filteredHeaders(headers, key) {
        if (arrayCount(headers) > 0) {
          return headers.filter(
            header =>
              header.view == null ||
              header.view[key] == null ||
              header.view[key] !== false
          );
        }
        return headers;
      },
      areasForSearch(areas) {
        if (arrayCount(areas) > 0) {
          return [...areas];
        }
        return [];
      }
    };
  }
};
Vue.filter("format", function(value) {
  if (value == null || isEmpty(value)) {
    return "";
  }
  return `${value}人`;
});

export default Facility;
